import { apiGET, apiPOST } from "../utils/apiHandler";

export const getLitigationClients = async (branchName) => {
    try {
        const response = await apiGET(`/litigation/api/clients/`, { branch_name: branchName });
        // Return the response directly - it already has the correct structure
        return response;
    } catch (error) {
        return error;
    }
};

export const getLitigationBranches = async (clientId) => {
    try {
        const response = await apiGET(`/litigation/api/branches/`, { client__id: clientId });
        // Return the response directly - it already has the correct structure
        return response;
    } catch (error) {
        return error;
    }
};

export const getInvoiceBranches = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/get-invoice-branches/`, params);
        return { status: true, data: response, message: response?.message };
    } catch (error) {
        return error;
    }
};

export const getCaseBranches = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/get-case-branches/`, params);
        return { status: true, data: response, message: response?.message };
    } catch (error) {
        return error;
    }
};

export const updateAdditionalDetails = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/update/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const createSingleCase = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/create/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const updateDetails = async (body) => {
    try {
        const response = await apiPOST(`litigation/api/case/update-generate/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCase = async (params) => {
    try {
       
        const requestParams = { ...(params || {}) };
        if (requestParams.client_id && !requestParams.client_id) {
            requestParams.client_id = requestParams.client_id;
            delete requestParams.client_id;
        }

        const response = await apiGET(`/litigation/api/cases`, requestParams);
        // Normalize API shape: `apiGET` returns the JSON body as `response`.
        // New API shape uses `response.data.results` as an object { summary, data: [...] }.
        // Callers expect `response.data.results` to be an array. Normalize in-place.
        try {
            const body = response || {};

            // Case A: response.data.results exists but is an object { summary, data: [...] }
            if (body.data && body.data.results && !Array.isArray(body.data.results)) {
                const nested = body.data.results;
                body.data.results = Array.isArray(nested.data) ? nested.data : [];
                if (nested.summary) body.summary = nested.summary;
                body.count = body.data.count ?? body.count;
                body.next = body.data.next ?? body.next;
                body.previous = body.data.previous ?? body.previous;
                body.page_number = body.data.page_number ?? body.page_number;
            }

            // Case B: some responses may return top-level `results` (legacy). Promote to data.results
            if (!body.data && body.results) {
                body.data = { results: Array.isArray(body.results) ? body.results : [] };
                body.count = body.count ?? (body.data?.count || 0);
                body.next = body.next ?? null;
                body.previous = body.previous ?? null;
            }

            // Case C: response.data.results already an array — nothing to do
        } catch (err) {
            console.error("Error normalizing getCase response:", err);
        }

        return response;
    } catch (error) {
        console.error("getCase API error details:", error?.response?.data || error);
        return error;
    }
};

export const getMissingFields= async (params) => {
    try {
        const response = await apiGET(`litigation/api/case/missing/data/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const postBatchData = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/bulk_create/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const batchListingAPI = async (params) => {
    try{
        const response = await apiGET('/litigation/api/litigation_batch/list/', params);
        return response
    } catch (error) {
        return error;
    }
}

export const updateEFiling = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/cases/update_case_number/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const addPocketExpance = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/expenses/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const caseDocumentUpload = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const generateSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/sample/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const approveSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/documents/generate/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const sendSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/generate/client`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const expanceListingAPI = async (params) => {
    try{
        const response = await apiGET(`/litigation/api/case/expenses/list/`, params);
        return response;
    } catch (error) {
        return error;
    }
}

export const caseDocumentDownload = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/case/document/list/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCasesMailHistory = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/case/email/conversations/`, params);
        return response;
    } catch (error) {
        return error;
    }
};
///litigation/api/request_court_fee/  get
export const requestCourtFee = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/request_court_fee/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

//Add Comment  - /litigation/api/add_comment/ - POST API
export const addComment = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/add_comments/`, body);
        return response;
    } catch (error) {
        return error;
    }
}

//Comment GET API - /litigation/api/get_comments/ - GET API
export const getComments = async (caseId) => {
    try {
        const response = await apiGET(`/litigation/api/get_comments/`, { case_id: caseId });
        return response;
    } catch (error) {
        return error;
    }
}

//List Invoice GET API - /litigation/api/list/case/invoices - GET API
export const listInvoice = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/list/case/invoices`, params);
        return response;
    } catch (error) {
        return error;
    }
}

// Get invoices by case id - returns { status: true, message, data: [...] }
export const getInvoicesByCaseId = async (caseId) => {
    try {
        const params = typeof caseId === 'object' ? caseId : { id: caseId };
        const response = await apiGET(`/litigation/api/get-invoices-by-case-id/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

//Create Invoice POST API - /litigation/api/create/case/invoice - POST API
export const createInvoice = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/create/case/invoice`, body);
        return response;
    } catch (error) {
        return error;
    }
}

export const getLitigationCaseTypes = async () => {
    try {
        const response = await apiGET(`/litigation/api/cases`);
        return { status: true, data: response, message: response?.message };
    } catch (error) {
        return error;
    }
};

{/* clientListingAPI */}
export const clientListingAPI = async (params) => {
    try{
        const response = await apiGET('/litigation/api/clients/cases/', params);
        return response
    } catch (error) {
        return error;
    }
}